<template>
	<div>
				<!-- <div class="t-headline11 font-m t-line-h-33 mgb-16">그로스 해킹 핵심 이론 시험</div> -->
				<div class="mdc-card  mgb-24 pdt-24 pdb-8 pdl-24 pdr-24">
					<div class="d-flex justify-content-between">
						<div class="t-headline7 font-m  mgb-16">{{$t('94')}}</div>
						<div class="t-subtitle3 font-m  mgb-16">Total {{$n(pointPolicy.applicationEarnPoint + pointPolicy.solveAllEarnPoint)}} Points</div>
					</div>
					<div class="pdt-16 pdb-16">
						<div class="d-flex">
							<div
								class="t-subtitle2 font-b p-24 bg-iconInactive t-color-white w-24 h-24 d-flex justify-content-center align-items-center b-radius50">
								P</div>
							<div class="t-body1 font-r t-color-bodyGrayA pdl-16 l-spacing48 flex-grow-1">{{$t('97')}}</div>
							<div class="t-body1 font-r">{{pointPolicy.applicationEarnPoint}} Points</div>
						</div>
					</div>
					<div class="pdt-16 pdb-16">
						<div class="d-flex">
							<div
								class="t-subtitle2 font-b p-24 bg-iconInactive t-color-white w-24 h-24 d-flex justify-content-center align-items-center b-radius50">
								P</div>
							<div class="t-body1 font-r t-color-bodyGrayA pdl-16 l-spacing48 flex-grow-1">
								{{$t('111')}}
							</div>
							<div class="t-body1 font-r">{{pointPolicy.solveAllEarnPoint}} Points</div>
						</div>
					</div>

				</div>

				<div class="mdc-card  mgb-50 pdt-24 pdb-8 pdl-24 pdr-24" v-if="badges.length">
					<div class="t-headline7 font-m  mgb-16">{{$t('112')}}</div>
					<div class="pdt-10 pdb-10 d-flex align-items-center" v-for="(badge, index) in badges" :key="index">
						<img v-if="badge.image" :src="badge.image" alt="" class="icon56">
						<div class="t-body1 font-r t-color-botyGrayA l-spacing48 pdl-20">
								{{badge.name}}
						</div>
					</div>
				</div>
	</div>
</template>

<script>
export default {
	props: ['pointPolicy','badges'],
}
</script>

<style scoped>

</style>